import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Golos Regular, sans-serif',
    },
});

export default theme;
